import { $$, $1, tap } from './utils';

// prettier-ignore
const PREFECTURES = [
  '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県',
  '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県',
  '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府',
  '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県',
  '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県',
  '鹿児島県', '沖縄県',
];
let phone;
const compositionRunning = new WeakSet();
const postalCodeCache = new WeakMap();
const body = document.body;

tap($1('input[type=tel]'), async () => {
  const res = await fetch('https://cdn.aisrvs.net/jp/phone.json');
  const { regexs } = await res.json();
  phone = regexs.map((re) => new RegExp(`^(?:${re})$`));
});

body.addEventListener('compositionstart', (ev) => compositionRunning.add(ev.target));
body.addEventListener('compositionend', (ev) => compositionRunning.delete(ev.target));

const oninput = (ev) => {
  const el = ev.target.closest('input:where([type=text],[type=tel])');
  if (el && !compositionRunning.has(ev.target)) checkElem(el);
};
body.addEventListener('input', oninput);
body.addEventListener('compositionend', oninput);

function checkElem(el) {
  if (el.value !== '') {
    const normalized = el.value.normalize('NFKC');
    if (el.type === 'tel') {
      checkTel(el, normalized);
    } else if (el.getAttribute('autocomplete')?.includes('postal-code')) {
      checkPostalCode(el, normalized);
    }
  }
}

function checkTel(el, value) {
  if (!phone) return;
  value = value.replace(/[- ]/g, '').replace(/^\+?81/, '0');
  for (const re of phone) {
    const match = re.exec(value);
    if (match) {
      const newValue = match.slice(1).join('-');
      if (el.value !== newValue) el.value = newValue;
      el.setCustomValidity('');
      return;
    }
  }
  el.setCustomValidity('正しい電話番号を入力してください。');
}

function checkPostalCode(el, value) {
  value = value.replace(/[- ]/g, '');
  const code = value.slice(0, 3);
  let cache;
  if (value.length >= 3) {
    cache = postalCodeCache.get(el);
    if (cache?.code !== code) {
      const prefetch = async () => {
        const res = await fetch(`https://cdn.aisrvs.net/jp/postal/${code}.json`);
        return res.ok && (await res.json());
      };
      cache = { code, promise: prefetch() };
      postalCodeCache.set(el, cache);
    }
  }
  if (value.length === 7) {
    cache.promise.then((postals) => {
      if (!postals) return;
      const postal = postals[value];
      if (!postal) return;

      const form = el.closest('form');
      el.value = `${code}-${value.slice(3)}`;
      const fills = {
        level1: PREFECTURES[postal[0] - 1],
        level2: postal[1] + postal[2],
        level3: postal[3],
        line1: postal[4],
        line2: null, // sentinel
      };
      const elems = {};
      for (const key of Object.keys(fills)) {
        const input = form.querySelector(`[autocomplete~="address-${key}"]`);
        elems[key] = input;
        if (input?.value) input.value = '';
      }
      let focused = false;
      for (const [key, value] of Object.entries(fills)) {
        const elem = elems[key];
        if (elem && value) {
          elem.value += value.normalize('NFKC');
        } else if (!focused) {
          elem?.focus();
          focused = true;
        }
      }
    });
  }
}

const toggleDestroy = (el) => {
  const fs = el.closest('fieldset');
  const elems = [...fs.elements].filter((e) => e !== el && e.type !== 'hidden');
  if (el.checked) {
    fs.dataset.disabledForDestroy = 'true';
    elems.forEach((e) => {
      e.dataset.destroyPreviousDisabled = e.disabled ? 'true' : 'false';
      if (e.classList.contains('tinymce')) tinymce.get(e.id)?.mode.set('readonly');
      e.disabled = true;
    });
  } else {
    delete fs.dataset.disabledForDestroy;
    elems.forEach((e) => {
      e.disabled = e.dataset.destroyPreviousDisabled === 'true';
      if (e.classList.contains('tinymce')) tinymce.get(e.id)?.mode.set(e.disabled ? 'readonly' : 'design');
      delete e.dataset.destroyPreviousDisabled;
    });
  }
};

body.addEventListener('change', (ev) => {
  const el = ev.target.closest('input:where([name="_destroy"],[name$="[_destroy]"])');
  if (el) toggleDestroy(el);
});
$$('input:where([name="_destroy"],[name$="[_destroy]"])').forEach(toggleDestroy);
